import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function PrivacyPage() {
  return (
    <div className="privacy-page">
      {/* Page Header */}
      <section className="page-header">
        <Container>
          <h1 className="page-title">Privacy Policy</h1>
          <p className="page-subtitle">
            個人情報保護方針
          </p>
        </Container>
      </section>

      {/* Privacy Policy Content */}
      <section className="section-privacy-content">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} data-aos="fade-up">
              <div className="privacy-body">
                <p className="privacy-intro">
                  PerfTech株式会社（以下「当社」）は、お客様の個人情報の重要性を認識し、
                  その保護に努めてまいります。以下のとおり個人情報保護方針を定め、
                  個人情報の適正な取り扱いと保護に努めます。
                </p>

                <div className="privacy-section">
                  <h3>1. 個人情報の定義</h3>
                  <p>
                    本方針における「個人情報」とは、個人情報保護法に定める個人情報を指し、
                    生存する個人に関する情報であって、氏名、生年月日、住所、電話番号、
                    メールアドレス等により特定の個人を識別できるものをいいます。
                  </p>
                </div>

                <div className="privacy-section">
                  <h3>2. 個人情報の取得</h3>
                  <p>
                    当社は、適正かつ公正な手段により個人情報を取得いたします。
                    主に以下の方法で個人情報を取得する場合があります。
                  </p>
                  <ul>
                    <li>当社ウェブサイトのお問い合わせフォームからのご連絡</li>
                    <li>メール、電話等によるお問い合わせ</li>
                    <li>お取引に伴う契約書類等の提出</li>
                    <li>採用応募に伴う履歴書等の提出</li>
                  </ul>
                </div>

                <div className="privacy-section">
                  <h3>3. 個人情報の利用目的</h3>
                  <p>当社は、取得した個人情報を以下の目的で利用いたします。</p>
                  <ul>
                    <li>お問い合わせへの回答およびご連絡</li>
                    <li>当社サービスに関する情報のご提供</li>
                    <li>お見積り・ご提案書等の作成</li>
                    <li>契約の締結・履行および関連する事務手続き</li>
                    <li>採用選考およびこれに関するご連絡</li>
                    <li>当社サービスの改善・新サービスの開発</li>
                    <li>その他、上記利用目的に付随する業務</li>
                  </ul>
                </div>

                <div className="privacy-section">
                  <h3>4. 個人情報の第三者提供</h3>
                  <p>
                    当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供いたしません。
                  </p>
                  <ul>
                    <li>法令に基づく場合</li>
                    <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                    <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                    <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
                  </ul>
                </div>

                <div className="privacy-section">
                  <h3>5. 個人情報の管理</h3>
                  <p>
                    当社は、個人情報の正確性および安全性を確保するために、
                    セキュリティ対策をはじめとする安全管理措置を講じ、
                    個人情報への不正アクセス、個人情報の紛失、破壊、改ざん
                    および漏洩等の防止に努めます。
                  </p>
                </div>

                <div className="privacy-section">
                  <h3>6. 個人情報の開示・訂正・削除</h3>
                  <p>
                    お客様ご本人から個人情報の開示、訂正、追加、削除、
                    利用停止のご請求があった場合、ご本人であることを確認の上、
                    速やかに対応いたします。
                  </p>
                </div>

                <div className="privacy-section">
                  <h3>7. Cookie（クッキー）の使用について</h3>
                  <p>
                    当社ウェブサイトでは、利便性の向上やアクセス状況の分析のために
                    Cookieを使用する場合があります。Cookieによって個人を特定できる情報を
                    取得することはありません。ブラウザの設定により、Cookieの受け取りを
                    拒否することも可能ですが、その場合、一部の機能がご利用いただけない
                    場合があります。
                  </p>
                </div>

                <div className="privacy-section">
                  <h3>8. 本方針の変更</h3>
                  <p>
                    当社は、必要に応じて本方針を変更することがあります。
                    変更後の個人情報保護方針は、当社ウェブサイトに掲載した時点から
                    効力を生じるものとします。
                  </p>
                </div>

                <div className="privacy-section">
                  <h3>9. お問い合わせ窓口</h3>
                  <p>
                    個人情報の取り扱いに関するお問い合わせは、
                    当社ウェブサイトのお問い合わせフォームよりご連絡ください。
                  </p>
                </div>

                <div className="privacy-company-info">
                  <p>PerfTech株式会社</p>
                  <p>〒103-0022 東京都中央区日本橋室町1-11-12 日本橋水野ビル7F</p>
                  <p>代表取締役 岩崎 厚樹</p>
                  <p className="privacy-date">制定日：2024年10月1日</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default PrivacyPage;
